import { render, staticRenderFns } from "./HomeIdeasPlaceKnowMore.vue?vue&type=template&id=7d4e4e31&scoped=true"
import script from "./HomeIdeasPlaceKnowMore.vue?vue&type=script&lang=ts"
export * from "./HomeIdeasPlaceKnowMore.vue?vue&type=script&lang=ts"
import style0 from "./HomeIdeasPlaceKnowMore.vue?vue&type=style&index=0&id=7d4e4e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e4e31",
  null
  
)

export default component.exports